module.exports = __webpack_public_path__ + "static/media/check-lesson.3ce921d9.svg";